import { render, staticRenderFns } from "./jiyang_list.vue?vue&type=template&id=4e48ad12&scoped=true&"
import script from "./jiyang_list.vue?vue&type=script&lang=js&"
export * from "./jiyang_list.vue?vue&type=script&lang=js&"
import style0 from "./jiyang_list.vue?vue&type=style&index=0&id=4e48ad12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e48ad12",
  null
  
)

export default component.exports